"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavThemeInlineVars = void 0;
var colord_1 = require("colord");
var mix_1 = __importDefault(require("colord/plugins/mix"));
var NavigationTheming_css_1 = require("./NavigationTheming.css");
var Goldilocks_1 = __importDefault(require("../Goldilocks"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
(0, colord_1.extend)([mix_1.default]);
var getNavThemeInlineVars = function (backgroundColor) {
    var useDarkTheme = (0, colord_1.colord)(backgroundColor).isDark();
    var preferredUiForegroundColor = useDarkTheme
        ? (0, colord_1.colord)(backgroundColor).mix("rgb(255 255 255 / 0.7)", 0.5).alpha(1).toRgbString()
        : (0, colord_1.colord)(backgroundColor).mix("rgb(0 0 0 / 0.5)", 0.5).alpha(1).toRgbString();
    var navThemeSubstitutions = {
        text: (0, Goldilocks_1.default)(backgroundColor, { mode: "text" }),
        ui: (0, Goldilocks_1.default)(backgroundColor, { mode: "ui", foregroundColor: preferredUiForegroundColor }),
        surface: backgroundColor,
    };
    var klThemeSubstitutions = useDarkTheme
        ? (0, dynamic_1.assignInlineVars)(tokens_1.tokens, __assign(__assign({}, tokens_1.structure), { color: __assign(__assign({}, tokens_1.structure.color), { icon: NavigationTheming_css_1.navigationTheme.color.ui, surface: NavigationTheming_css_1.navigationTheme.color.surface, surfaceHover: "rgb(255 255 255 / 0.1)", surfaceActive: "rgb(255 255 255 / 0.08)", border: "rgb(255 255 255 / 0.1)", text: NavigationTheming_css_1.navigationTheme.color.text }), shadow: __assign(__assign({}, tokens_1.structure.shadow), { elevation2: "inset 0 1px 0 0 rgb(229 236 244 / .2), 0 1px 3px rgb(0 0 0 / .16), 0 20px 36px -10px rgb(0 0 0 / .2), 0 0 10px rgb(0 0 0 / .12), 0 8px 20px -6px rgb(0 0 0 / .12)" }) }))
        : (0, dynamic_1.assignInlineVars)(tokens_1.tokens, __assign(__assign({}, tokens_1.structure), { color: __assign(__assign({}, tokens_1.structure.color), { icon: NavigationTheming_css_1.navigationTheme.color.ui, surface: NavigationTheming_css_1.navigationTheme.color.surface, surfaceHover: "rgb(0 0 0 / 0.05)", surfaceActive: "rgb(0 0 0 / 0.04)", border: "rgb(0 0 0 / 0.1)", text: NavigationTheming_css_1.navigationTheme.color.text }) }));
    return __assign(__assign({}, (0, dynamic_1.assignInlineVars)(NavigationTheming_css_1.navigationTheme, {
        color: navThemeSubstitutions,
    })), klThemeSubstitutions);
};
exports.getNavThemeInlineVars = getNavThemeInlineVars;
